export const WALLET_CONNECTOR_DATA = 'WALLET_CONNECTOR_DATA';

export const GET_BNB_BALANCE_LOADING = 'GET_BNB_BALANCE_LOADING';
export const GET_BNB_BALANCE_LOADED = 'GET_BNB_BALANCE_LOADED';
export const GET_BNB_BALANCE_ERROR = 'GET_BNB_BALANCE_ERROR';

export const GET_USDT_ALLOWANCE_LOADING = 'GET_USDT_ALLOWANCE_LOADING';
export const GET_USDT_ALLOWANCE_LOADED = 'GET_USDT_ALLOWANCE_LOADED';
export const GET_USDT_ALLOWANCE_ERROR = 'GET_USDT_ALLOWANCE_ERROR';


export const onWalletConnect = (data) => {
    console.log('onWalletConnect data --> ',data);
    return dispatch => {
        dispatch({ type: WALLET_CONNECTOR_DATA, payload: { data: data } });
    }
}

export const onWallectDisconnect = () => {
    return dispatch => {
        dispatch({ type: WALLET_CONNECTOR_DATA, payload: { data: undefined } });
    }
}

const ACTION_HANDLERS = {
    [WALLET_CONNECTOR_DATA] : (state, action)=>{
        return {
            data: action.payload.data
        }
    },
    [GET_BNB_BALANCE_LOADING] : (state, action)=>{
        return {
            ...state,
            myBNBLoading : true,
            myBNBLoaded : false,
            myBNBError: false,
            myBNBErrorMsg : ''
        }
    },
    [GET_BNB_BALANCE_LOADED] : (state, action)=>{
        let data = action.payload.data;
        return {
            ...state,
            myBNBLoading : false,
            myBNBLoaded : true,
            myBNBError : false,
            myBNBData : data,
            myBNBErrorMsg : ''
        }
    },
    [GET_BNB_BALANCE_ERROR] : (state, action)=>{
        return {
            ...state,
            myBNBLoading : false,
            myBNBLoaded : false,
            myBNBData : undefined,
            myBNBError : JSON.stringify(action.payload.error)
        }
    },
    [GET_USDT_ALLOWANCE_LOADING] : (state, action)=>{
        return {
            ...state,
            usdtAllowanceLoading : true,
            usdtAllowanceLoaded : false,
            usdtAllowanceError: false,
            usdtAllowanceErrorMsg : ''
        }
    },
    [GET_USDT_ALLOWANCE_LOADED] : (state, action)=>{
        let data = action.payload.data;
        return {
            ...state,
            usdtAllowanceLoading : false,
            usdtAllowanceLoaded : true,
            usdtAllowanceError : false,
            usdtAllowanceData : data,
            usdtAllowanceErrorMsg : ''
        }
    },
    [GET_USDT_ALLOWANCE_ERROR] : (state, action)=>{
        return {
            ...state,
            usdtAllowanceLoading : false,
            usdtAllowanceLoaded : false,
            usdtAllowanceData : undefined,
            usdtAllowanceError : JSON.stringify(action.payload.error)
        }
    },

};

const initialState = {
    data : undefined,

    myBNBLoading : false,
    myBNBLoaded : false,
    myBNBError : false,
    myBNBData : undefined,
    myBNBErrorMsg : '',

    usdtAllowanceLoading : false,
    usdtAllowanceLoaded : false,
    usdtAllowanceError : false,
    usdtAllowanceData : undefined,
    usdtAllowanceErrorMsg : '',


};

export default function noticeReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};